export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Regionais criados com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar regionais.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Regionais criados com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar regionais.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Regionais criados com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar regionais.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
